import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import Messages from './Messages';

SectionMessages.propTypes = {};

function SectionMessages({ section }) {
  const { sectionName, sectionMsgs } = section;

  return (
    <Box>
      {/* <Typography variant="body1">
        <b>{sectionName}</b>
      </Typography> */}
      <Messages messages={sectionMsgs} />
    </Box>
  );
}

export default SectionMessages;
